import api from './api'

export const fetchPendingRecommendations = ({ limit } = {}) =>
	api.get('/counseling/dashboard/recommendations-pending', {
		params: {
			limit: Number.isFinite(Number(limit)) ? Number(limit) : undefined,
		},
	})

export const markStudentRecommendationsSeen = (
	studentId,
	{ anchorAt, applicationTargetId } = {},
) =>
	api.post(
		`/counseling/dashboard/students/${encodeURIComponent(studentId)}/recommendations/seen`,
		{
			anchor_at: anchorAt || undefined,
			applicationTargetId: applicationTargetId || undefined,
		},
	)
